import { render, staticRenderFns } from "./BoFaq.vue?vue&type=template&id=a4dd7928&"
import script from "./BoFaq.vue?vue&type=script&lang=js&"
export * from "./BoFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports